import React from 'react'

export default function GetUrl() {


    return "https://mxgsesoftware.com/digitalprepagoback/"

    //return "http://localhost:3101/digitalprepagoback/" // desarollo
    
}
